import React from 'react';
import Draggable from 'react-draggable';
import {connect} from 'react-redux';
import { openModal, closeModal } from '../../Redux/actions/ui.js';
import { toggleEditorDocked, toggleRightDock, setActiveTab } from '../../Redux/actions/rightDock.js';
import SubmitDeposit from './Popups/SubmitDeposit.js';
import ProjectDirectory from './Popups/ProjectDirectory.js';
import TenementDirectory from './Popups/TenementDirectory.js';
import HelpInfo from './Popups/HelpInfo.js';
import RegisterInterest from './Popups/RegisterInterest.js';
import RegisterAccount from './Popups/RegisterAccount.js';
import InventumSlideEditor from './Popups/InventumSlideEditor.js';

import InventumLabelEditor from './Popups/editor_v2/labels/Labels.js';
import InventumLightsEditor from './Popups/editor_v2/lights/Lights.js';
import InventumClippingEditor from './Popups/editor_v2/clipping/Clipping.js';
import InventumWorldEditor from './Popups/editor_v2/world/World.js';

import InventumAssetManager from './Popups/InventumAssetManager.js';
import { canAccessEditorModal, selectPermissionCapabilities } from '../../utils/permissions.js';
import { dockFloatingEditorOnly } from './modalDocking.js';
import { DOCK_TO_LEFT_ICON, DOCK_TO_LEFT_ICON_CLASS } from './dockControls.js';
import InventumProjectHistory from './Popups/InventumProjectHistory.js';
import AnalyticsDirectory from './Popups/AnalyticsDirectory.js';
import PasswordReset from './Popups/PasswordReset.js';
import MeetingCreator from './Popups/MeetingCreator.js';
import SettingsEditor from './Popups/SettingsEditor.js';
import InventumSceneFileEditor from './Popups/editor_v2/SceneFileEditor.js';

import SignIn from './Popups/SignIn.js';
import ReAuthorize from './Popups/ReAuthorize.js';
import SiteAdminsDirectory from './Popups/SiteAdminsDirectory.js';


class TutorialBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showTutorial:false,popped:false}
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentDidMount() {
    if (!window.localStorage.getItem('Tutorial_1_Completed')) {
      this.setState({showTutorial:true})
      setTimeout(()=>{this.setState({popped:true})},2500)
    }
  }

  handleDismiss() {
    window.localStorage.setItem('Tutorial_1_Completed',true);
    this.setState({popped:false});
    setTimeout(()=>{this.setState({showTutorial:false})},1500)
  }


  render() {
    if (!this.state.showTutorial || this.props.pageMode === "3D") {
      return null;
    }

    return (
      <div className={"BarNotification" + (this.state.popped ? " visible" : "")}>Click on a Label <i className="material-icons notranslate">pin_drop</i> to view the Project in 3D <div onClick={this.handleDismiss} className="DismissButton">Got It</div></div>
    )
  }
}


class EditorContainer extends React.Component {
  constructor(props) {
    super(props);
    // Access policy for these modal names is centralized in `canAccessEditorModal`
    // (src/ui/utils/permissions.js).
    this.MODALS = [
			{ name: 'HelpInfo', title: 'Help', el: HelpInfo, icon: 'help' },
			{ name: 'SettingsEditor', title: 'Settings Editor', el: SettingsEditor, icon: 'settings' },
	/*  { name: 'InventumAnimationEditor', title: 'Animation Editor', el: InventumLabelEditor, icon: 'apps', requiresEditor: true, requiresProjectEdit: true }, */
      { name: 'InventumLabelEditor', title: 'Label Editor', el: InventumLabelEditor, icon: 'label', requiresEditor: true, requiresProjectEdit: true },
      { name: 'InventumLightsEditor', title: 'Lights Editor', el: InventumLightsEditor, icon: 'tungsten', requiresEditor: true, requiresProjectEdit: true },
      { name: 'InventumClippingEditor', title: 'Clipping Editor', el: InventumClippingEditor, icon: 'compare', requiresEditor: true, requiresProjectEdit: true },
      { name: 'InventumWorldEditor', title: 'World Editor', el: InventumWorldEditor, icon: 'public', requiresEditor: true, requiresProjectEdit: true },
      { name: 'InventumSlideEditor', title: 'Legacy Slide Editor', el: InventumSlideEditor, icon: 'picture_in_picture', requiresEditor: true, adminOnly: true },
			{ name: 'InventumSceneFileEditor', title: 'Advanced Scene Editor', el: InventumSceneFileEditor, icon: 'code', requiresEditor: true, adminOnly: true }
    ]
  }

  canAccessModal(modal) {
    return canAccessEditorModal(modal.name, {
      siteAdmin: this.props.siteAdmin,
      canEditProject: this.props.canEditProject,
      editMode: this.props.editMode
    });
  }

  render () {
    const accessibleModals = this.MODALS.filter((modal) => this.canAccessModal(modal));

    if (!accessibleModals.find((modal) => modal.name === this.props.activeModal)) {
      return null;
    }

    const isDocked = this.props.isDocked || false;

    const DockBtn = () => {
      const handleDock = () => {
        // Close the floating modal
        this.props.closeModal();
        // Trigger dock mode
        if (this.props.toggleEditorDocked) {
          this.props.toggleEditorDocked(true);
        }
        if (this.props.toggleRightDock) {
          this.props.toggleRightDock(true);
        }
        if (this.props.setActiveTab) {
          this.props.setActiveTab('editor');
        }
        // Reopen the modal in docked mode
        setTimeout(() => this.props.openModal(this.props.activeModal), 100);
      };
      
      return (
        <div title='Dock to right side' className='EditorHeaderButton' onClick={handleDock}><i className={DOCK_TO_LEFT_ICON_CLASS}>{DOCK_TO_LEFT_ICON}</i></div>
      )
    }

    const CloseBtn = () => {
      const handleCloseToDock = (e) => {
        e.stopPropagation();
        dockFloatingEditorOnly(this.props);
      };

      return (
        <div title='Close to dock' className='EditorHeaderButton' onClick={handleCloseToDock}><i className="material-icons notranslate">close</i></div>
      )
    }

    const EditorModalHeader = () => {
      const activeModalData = accessibleModals.find(m => m.name === this.props.activeModal);
      return (
        <div className='EditorModalHeader'>
          <span className='EditorModalTitle'>{activeModalData?.title || 'Editor'}</span>
          <div className='EditorModalControls'>
            {!isDocked && <DockBtn />}
            {!isDocked && <CloseBtn />}
          </div>
        </div>
      );
    }

    const EditorModalFooter = () => {
      return <div className='EditorModalFooter'></div>;
    }

    const EditorEl = () => {
      return (
        <>
          {isDocked ? null : <EditorModalHeader />}
          <div className='EditorInnerWrapper'>
            <div className='EditorModeSelectPanel'>
              {accessibleModals.map((modal, index) => {
                return (
                  <div onClick={() => {
                    if (this.props.activeModal === modal.name) return;
                    this.props.openModal(modal.name)
                  }}
                  title={modal.title}
                  key={index}
                  className={'EditorTabIcon' + (this.props.activeModal === modal.name ? ' active' : '')}>
                    <i className="material-icons notranslate">{modal.icon}</i>
                  </div>)
               })}
            </div>
            <div className='EditorPanel'>
              {accessibleModals.map((modal, index) => {
                let Element = modal.el;
                if (this.props.activeModal === modal.name) return <Element key={index} />;
                return null;
              })}
            </div>
          </div>
          {isDocked ? null : <EditorModalFooter />}
        </>
      )
    }

    // When docked, render without Draggable wrapper
    if (isDocked) {
      return (
        <div className='EditorContainer docked'>
          <EditorEl />
        </div>
      )
    }

    return (
			<Draggable handle='.EditorModalHeader, .EditorModalFooter'>
				<div className='EditorContainer'>
	        <EditorEl />
	      </div>
			</Draggable>
    )
  }
}

const PopupContainer = (props) => {
  let style = {
    "display":"flex",
    "justifyContent":"center",
    "alignItems":"center",
    "position":"absolute",
    "width":"100%",
    "height":"100%"
  }
  
  // Only render EditorContainer as floating modal if not docked
  const shouldShowFloatingEditor = !props.editorDocked;
  
  return (
    <div className="PopupContainer" style={style}>
      {props.activeModal === "SubmitDeposit" ? <SubmitDeposit /> : null}
      {props.activeModal === "AnalyticsDirectory" ? <AnalyticsDirectory /> : null}
      {props.activeModal === "ProjectDirectory" ? <ProjectDirectory /> : null}
      {props.activeModal === "TenementDirectory" ? <TenementDirectory /> : null}
      {props.activeModal === "RegisterInterest" ? <RegisterInterest /> : null}
      {props.activeModal === "RegisterAccount" ? <RegisterAccount /> : null}
      {props.activeModal === "InventumAssetManager" ? <InventumAssetManager /> : null}
      {props.activeModal === "PasswordReset" ? <PasswordReset /> : null}
      {props.activeModal === "SignIn" ? <SignIn /> : null}
      {props.activeModal === "ReAuthorize" ? <ReAuthorize /> : null}
      {props.activeModal === "SiteAdminsDirectory" ? <SiteAdminsDirectory /> : null}
      {props.activeModal === "InventumProjectHistory" ? <InventumProjectHistory /> : null}
      {props.activeModal === "MeetingCreator" ? <MeetingCreator /> : null}
      {shouldShowFloatingEditor ? (
        <EditorContainer 
          editMode={props.editMode} 
          siteAdmin={props.siteAdmin} 
          canEditProject={props.canEditProject}
          openModal={props.openModal} 
          closeModal={props.closeModal} 
          activeModal={props.activeModal}
          isDocked={false}
          toggleEditorDocked={props.toggleEditorDocked}
          toggleRightDock={props.toggleRightDock}
          setActiveTab={props.setActiveTab}
        />
      ) : null}
      <TutorialBar pageMode={props.pageMode} />
    </div>
  )
}

let mapStateToProps = (state) => {
  const caps = selectPermissionCapabilities(state);

  return {
    activeModal: state.ui.activeModal,
    pageMode: state.sidebarUI.mode,
	  editMode: state.ui.editMode,
	  // Legacy prop name retained for compatibility; capability-based source.
	  siteAdmin: caps.isTrueSiteAdmin,
    canEditProject: caps.canEditProject,
    editorDocked: state.rightDock.editorDocked,
  };
}

let mapDispatchToProps = dispatch => ({
  openModal: (value) => {
    dispatch(openModal(value));
  },
  closeModal: () => {
    dispatch(closeModal());
  },
  toggleEditorDocked: (value) => {
    dispatch(toggleEditorDocked(value));
  },
  toggleRightDock: (value) => {
    dispatch(toggleRightDock(value));
  },
  setActiveTab: (value) => {
    dispatch(setActiveTab(value));
  }
})


const PopupContainerWrapper = connect(mapStateToProps,mapDispatchToProps)(PopupContainer)

// Export EditorContainer separately for use in RightDockContainer
const EditorContainerConnected = connect(
  (state) => {
    const caps = selectPermissionCapabilities(state);

    return {
      activeModal: state.ui.activeModal,
      // Legacy prop name retained for compatibility; capability-based source.
      siteAdmin: caps.isTrueSiteAdmin,
      canEditProject: caps.canEditProject,
      editMode: state.ui.editMode,
      editorDocked: state.rightDock.editorDocked
    };
  },
  (dispatch) => ({
    openModal: (value) => dispatch(openModal(value)),
    closeModal: () => dispatch(closeModal()),
    toggleEditorDocked: (value) => dispatch(toggleEditorDocked(value)),
    toggleRightDock: (value) => dispatch(toggleRightDock(value)),
    setActiveTab: (value) => dispatch(setActiveTab(value))
  })
)(EditorContainer);

export { EditorContainerConnected };
export default PopupContainerWrapper;
